// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Z5e_w{height:24px;width:24px;object-fit:contain;display:flex;align-items:center;justify-content:center}.Xk9dP{width:auto;min-width:24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image": `Z5e_w`,
	"fullLogo": `Xk9dP`
};
export default ___CSS_LOADER_EXPORT___;
